<template>
	<el-container class="course_sele">
        <div class="con">
            <div class="live">
			    <div class="titBox" v-if="login">
			    	<p class="tit">选课中心
			    	</p>
			    </div>
                <div class="course_selection">
                    <div class="course_selection_l" v-if="login">
                        <div class="course_selection_hed">已选课程</div>
                        <div v-for="cou_item,cou_key in selected_courses_data" :key="'cou'+cou_key">
                            <div v-if="cou_item.list.length">
                                <div class="selected_course_mould">
                                    {{cou_item.name}}
                                </div>
                                <div class="selected_course" v-for="(maj_item,maj_i) in cou_item.list" :key="maj_i">
                                    <div class="selected_course_hed">
                                        <span>{{maj_item.course_name}}</span>
                                        <span class="red" @click="cou_red(cou_key,maj_i)">删除</span>
                                    </div>
                                    <div class="selected_course_data">{{maj_item.course_type_format}} {{maj_item.study_hour}}学时 </div>
                                </div>
                                <div class="set_data">
                                    <span>已选 <span style="color:#2991e1;">{{cou_item.list.length}}</span>门课</span>
                                    <span>合计 <span style="color:#2991e1;">{{study_hour_sum(cou_key)}}</span> 学时</span>
                                </div>
                            </div>
                            
                        </div>
                        <div class="btn">
                            <el-button size="mini" type="primary" v-if="sou_study_sum!=0" @click="submit">保存选课方案</el-button>
                        </div>
                    </div>
                    <div class="course_selection_r">
                        <div class="classification" v-for="(item ,i) in options_data" :key="i">
                            <div class="classification_name">{{item.label}}</div>
                            <div class="classification_data">
                                <div :class="!options_id[item.name]?'classification_show':''" @click="switch_fn(item.name,0,'subdivision')">全部</div>
                                <div v-for="(op_item,op_i) in item.options" :key="'op'+op_i"  @click="switch_fn(item.name,op_item,'subdivision')" :class="options_id[item.name]==op_item.value?'classification_show':''">
                                    {{op_item.label}}
                                </div>
                            </div>
                        </div>

                        <div class="classification">
                            <div class="classification_name">专业细分</div>
                            <div class="classification_data">
                                <div :class="!options_id[subdivision_options.name]?'classification_show':''" @click="switch_fn(subdivision_options.name,0)">全部</div>
                                <div  :class="options_id[subdivision_options.name]==item.value?'classification_show':''" v-for="(item,i) in subdivision_options.children" :key="'f'+i" @click="switch_fn(subdivision_options.name,item)">{{item.label}}</div>
                            </div>
                        </div>
                         <!-- v-loading="history_load" -->
                        <ul class="zui" v-if="course_list.length">
                             <!-- @click="courseClick(item, 'history')" -->
			            	<li v-for="(item,i) in course_list" :key="i">
			            		<div class="coverbox">
			            			<div class="course_type" >{{item.course_type_format}}</div>
			            			<!-- <img v-if="item.thumb != '-' && item.thumb != 1" :src="global.oss_website+item.thumb"> -->
			            			<div class="courseImgContent">{{item.course_name}}</div>
			            		</div>
			            		<div class="courseTitBox">
                                    <p class="tit">{{item.course_name}}</p>
                                    <p>课时：{{item.study_hour}}</p>
                                    <p>专业：{{item.major_name}}</p>
                                    <el-button type="primary" size="mini" @click="selected(item)" v-if="login&&item.is_selected==2">选课</el-button>
                                    <el-button type="info" size="mini" v-if="login&&item.is_selected==1">已选</el-button>
                                </div>
			            	</li>
			            </ul>
                        <div class="nodata" v-else style="height: 360px;">
			            	<img style="width: 300px;" :src="global.oss_website+'/wap/images/no_data_img.jpg'">
			            	<p>专业暂无课程</p>
			            </div>
                        <el-pagination
                          v-if="course_list.length"
                          background
                          @current-change="handleCurrentChange"
                          layout="prev, pager, next"
                          :current-page="params.page"
    		              :page-size="params.limit"
                          :total="params.total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </el-container>
</template>
<script>
export default {
	name: 'course_sele'
    ,components:{
    }
	,data () {
		return {
            class_show:0,
            options_id:{},
            options_data:[],
            subdivision_options:{
                children:[],
                name:'',
            },
            params:{
				page:1,
				limit:8,
                total:0
			},
            course_list:[],
            selected_courses_data:{},
            sou_study_sum:0,
            login:false,
		}
	}
	,mounted:function(){
        if (this.$cookies.get("token")) {
            this.login = true
            this.params.limit = 6
        }
        this.$store.dispatch('get_identity_list').then(res=>{
			// console.log(res);
			if (res.length>=1) {
                this.user_course_my()
			}
		})
        this.user_course()
        this.options()
	}
	,watch:{
	}
	,computed:{
        study_hour_sum(){
            return (key)=>{
                let sum = 0
                this.selected_courses_data[key].list.map((v)=>{
                    sum+=parseInt(v.study_hour)
                })
                return sum
            }
        },
        
	}
	,methods:{
        //获取课程类型
        options(){
            let that = this
		    this.$ajax.get(
		    	this.global.serverSrc + this.global.qianzui + '/user_course/options'
		    )
		    .then(function (res){
		    	let resData = res.data
		    	if(resData.code==0){
                    that.options_data = resData.data
		    		// console.log(res);
                    // console.log(that.options_data);
		    		// console.log(that.index_news_list);
		    	}else{	

		    	}
		    })
        },
        //点击选课
        selected(item){
            if (this.selected_courses_data[item.mould_id]) {
                this.selected_courses_data[item.mould_id].name = item.major_name
                if (!this.selected_courses_data[item.mould_id].list.some(v=>{ return v.course_id==item.course_id })) {
                    this.selected_courses_data[item.mould_id].list.push(item)
                }
            }else{
                this.selected_courses_data[item.mould_id] = {
                    name:item.major_name,
                    list:[item]
                }
            }
            item.is_selected = 1
            this.sou_study_sum_fn()
            this.course_determine()
            this.$forceUpdate();
        },
        //请求课程列表
        user_course(){
            let that = this
            this.$ajax.get(
		    	this.global.serverSrc + this.global.qianzui + '/user_course',{
		        	params: {...that.options_id,...that.params}
		        }
		    )
		    .then(function (res){
                console.log(res);
		    	let resData = res.data
		    	if(resData.code==0){
                    that.course_list = resData.data.data
                    that.params.total = resData.data.total
                    that.course_determine()
		    		// console.log(res);
                    // console.log(that.options_data);
		    		// console.log(that.index_news_list);
		    	}else{	

		    	}
		    })
        },
        //请求已选课程
        user_course_my(){
            if (!this.login) {
                return false
            }
            let that = this
            this.$ajax.get(
		    	this.global.serverSrc + this.global.qianzui + '/user_course/my'
		    )
		    .then(function (res){
                let resData = res.data
		    	if(resData.code==0){
                    for (let i = 0; i < resData.data.length; i++) {
                        let sele_data = resData.data[i]
                        that.selected_courses_data[sele_data.mould_id] = {
                            name:sele_data.name,
                            list:sele_data.courses
                        }
                    }
                    that.sou_study_sum_fn()
                    that.course_determine()
                    that.$forceUpdate();
                }
                
		    })
        },
        handleCurrentChange(data){
            this.params.page = data
            this.user_course()
        },
        //类型点击
        switch_fn(options_id_name,item,type){
            this.$set(this.options_id,options_id_name,item?item.value:0)
            if (type=='subdivision') {
                if (item) {
                    this.subdivision_options = {...item}
                }else{
                    this.subdivision_options.children = []
                }
                this.$set(this.options_id,this.subdivision_options.name,0)
                
            }else{
                // this.subdivision_options = {
                //     children:[],
                //     name:'',
                // }
            }
            this.user_course()
            // if (type=='subdivision') {
            //     this.options_id[item.name] = 0
            // }
            // this.options_id[options_id_name] = item.value
            // console.log(this.options_id);
            // console.log(item.value);
        },
        //删除课程
        cou_red(key,i){
            this.selected_courses_data[key].list.splice(i,1)
            this.sou_study_sum_fn()
            this.course_determine()
            this.$forceUpdate();
        },
        //课程总数
        sou_study_sum_fn(){
            this.sou_study_sum = 0
            for (const key in this.selected_courses_data) {
                this.selected_courses_data[key].list.map((v)=>{
                    this.sou_study_sum+=parseInt(v.study_hour)
                })
            }
        },
        //保存已选课程
        submit(){
            let data = []
            let that = this
            for (const key in this.selected_courses_data) {
                for (let i = 0; i < this.selected_courses_data[key].list.length; i++) {
                    let obj = this.selected_courses_data[key].list[i]
                    data.push({
                        mould_id:obj.mould_id,
                        course_id:obj.course_id,
                        user_course_id:obj.user_course_id,
                    })
                }
            }
            if (data.length===0) {
                this.$message.error('请选择课程！');
                return false
            }
            this.$ajax.post(
		    	this.global.serverSrc + this.global.qianzui + '/user_course/submit',
                this.$qs.stringify({selected:data})
		    )
		    .then(function (res){
		    	let resData = res.data
		    	if(resData.code==0){
                    that.$message.success('操作成功！');
                    window.location.reload()
                    // that.options_data = resData.data
		    		// console.log(res);
                    // console.log(that.options_data);
		    		// console.log(that.index_news_list);
		    	}else{	

		    	}
		    })
        },
        //判断选课
        course_determine(){
            for (const key in this.selected_courses_data) {
                for (let i = 0; i < this.selected_courses_data[key].list.length; i++) {
                    let obj = this.selected_courses_data[key].list[i]
                    this.course_list.map(v=>{
                        if (obj.course_id==v.course_id) {
                            v.sele = true
                        }else{
                            v.sele = false
                        }
                    })
                }
            }
        }
	}
	,destroyed:function(){
	}
}
</script>
<!-- scoped单页面有效属性 -->

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/dyy_assembly/courseSele.vue